import { render, staticRenderFns } from "./laborPassList.vue?vue&type=template&id=1130138f"
import script from "./laborPassList.vue?vue&type=script&lang=js"
export * from "./laborPassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports